import API from "../base.service";
import { ENDPOINT } from "../../constants.service";

const saveShelfRecord = async (data, json) => {
  return await API.postMethod(
    `${ENDPOINT.products.shelf.create}`,
    true,
    data,
    json ? false : true,
  );
};
const saveIndividualRack = async (data, json) => {
  return await API.postMethod(
    ENDPOINT.products.shelf.saveRack,
    true,
    data,
    json ? false : true,
  );
};
const productFromCatalog = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.products.product.fromCatalog}`,
    true,
    data,
    true,
  );
};
const updateProduct = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.products.shelf.create}`,
    true,
    data,
    true,
  );
};
const productList = async (data) => {
  return await API.getMethod(
    `${ENDPOINT.products.product.list}`,
    true,
    true,
    data,
  );
};
const deleteProduct = async (id) => {
  const url = `${ENDPOINT.products.product.delete}`.replace(":id", id);
  return await API.deleteMethod(url, true);
};
const getSaveProduct = async (id) => {
  const url = `${ENDPOINT.products.shelf.show}`.replace(":id", id);
  return await API.getMethod(url, true);
};
const exportProducts = async (data) => {
  return await API.postMethod(ENDPOINT.products.product.exportAs, true, data);
};
const exportShelfManagement = async (id) => {
  const url = `${ENDPOINT.products.shelf.exportAsExcel}`.replace(":id", id);
  return await API.getMethod(url, true);
};

export default {
  getSaveProduct,
  saveShelfRecord,
  updateProduct,
  productList,
  deleteProduct,
  productFromCatalog,
  exportProducts,
  saveIndividualRack,
  exportShelfManagement
};
